/**
 * Junta classes ignorando falsy. Usado por todo componente do design system.
 *
 *   cx(s.base, ativo && s.ativo, className)
 */
export default function cx(...partes) {
  return partes.filter(Boolean).join(' ');
}
